export default {
  mutations: {
    updateIsMenuActiveMutation(state?: any, isMenuActive?: boolean) {
      state.isMenuActive = isMenuActive;
    },
    updateIsMobileMenuActiveMutation(
      state?: any,
      isMobileMenuActive?: boolean
    ) {
      state.isMobileMenuActive = isMobileMenuActive;
    },
    updateIsCardLostModaleActiveMutation(
      state?: any,
      isCardLostActiveModale?: boolean
    ) {
      state.isCardLostActiveModale = isCardLostActiveModale;
    },
    updateIsCardStolenModaleActiveMutation(
      state?: any,
      isCardStolenActiveModale?: boolean
    ) {
      state.isCardStolenActiveModale = isCardStolenActiveModale;
    },
    updateIsGenericErrorModaleActiveMutation(
      state?: any,
      isGenericErrorModaleActive?: boolean
    ) {
      state.isGenericErrorModaleActive = isGenericErrorModaleActive;
    },
    updateGenericErrorModalMessageMutation(
      state?: any,
      genericErrorModalMessage?: string
    ) {
      state.genericErrorModalMessage = genericErrorModalMessage;
    },
    updateIsDisplayChangePINActiveMutation(
      state?: any,
      isActiveDisplayChangePINModale?: boolean
    ) {
      state.isActiveDisplayChangePINModale = isActiveDisplayChangePINModale;
    },
    updateIsDisplayFreezeCardActiveMutation(
      state?: any,
      isActiveFreezeCardModale?: boolean
    ) {
      state.isActiveFreezeCardModale = isActiveFreezeCardModale;
    },
    updateIsActiveSetNewPinModaleMutation(
      state?: any,
      isActiveSetNewPinModale?: boolean
    ) {
      state.isActiveSetNewPinModale = isActiveSetNewPinModale;
    },
    updateIsActiveConfirmSetNewPinModaleMutation(
      state?: any,
      isActiveConfirmSetNewPinModale?: boolean
    ) {
      state.isActiveConfirmSetNewPinModale = isActiveConfirmSetNewPinModale;
    },
    updateIsDisplayPinModaleActiveMutation(
      state?: any,
      isDisplayPinModaleActive?: boolean
    ) {
      state.isDisplayPinModaleActive = isDisplayPinModaleActive;
    },
    updateIsLoginButtonLoadingMutation(
      state?: any,
      isLoginButtonLoading?: boolean
    ) {
      state.isLoginButtonLoading = isLoginButtonLoading;
    },
    updateIsRegistrationProceedButtonLoadingMutation(
      state?: any,
      isRegistrationProceedButtonLoading?: boolean
    ) {
      state.isRegistrationProceedButtonLoading = isRegistrationProceedButtonLoading;
    },
    updateIsSendingInvitationEmailButtonLoadingMutation(
      state?: any,
      isSendingInvitationEmailButtonLoading?: boolean
    ) {
      state.isSendingInvitationEmailButtonLoading = isSendingInvitationEmailButtonLoading;
    },
    updateIsUpdateMyVehicleButtonLoadingMutation(
      state?: any,
      isUpdateMyVehicleButtonLoading?: boolean
    ) {
      state.isUpdateMyVehicleButtonLoading = isUpdateMyVehicleButtonLoading;
    },
    updateIsFreezeCardButtonLoadingMutation(
      state?: any,
      isFreezeCardButtonLoading?: boolean
    ) {
      state.isFreezeCardButtonLoading = isFreezeCardButtonLoading;
    },
    updateIsActivateCardButtonLoadingMutation(
      state?: any,
      isActivateCardButtonLoading?: boolean
    ) {
      state.isActivateCardButtonLoading = isActivateCardButtonLoading;
    },
    updateIsReportCardLostButtonLoadingMutation(
      state?: any,
      isReportCardLostButtonLoading?: boolean
    ) {
      state.isReportCardLostButtonLoading = isReportCardLostButtonLoading;
    },
    updateIsReportCardStolenButtonLoadingMutation(
      state?: any,
      isReportCardStolenButtonLoading?: boolean
    ) {
      state.isReportCardStolenButtonLoading = isReportCardStolenButtonLoading;
    },
    updateIs2FALoginButtonLoadingMutation(
      state?: any,
      is2FALoginButtonLoading?: boolean
    ) {
      state.is2FALoginButtonLoading = is2FALoginButtonLoading;
    },
    updateIsPostCardNumberToSendResetPasswordSmsCodeButtonLoadingMutation(
      state?: any,
      isPostCardNumberToSendResetPasswordSmsCodeButtonLoading?: boolean
    ) {
      state.isPostCardNumberToSendResetPasswordSmsCodeButtonLoading = isPostCardNumberToSendResetPasswordSmsCodeButtonLoading;
    },
    updateIsSetNewPasswordButtonLoadingMutation(
      state?: any,
      isSetNewPasswordButtonLoading?: boolean
    ) {
      state.isSetNewPasswordButtonLoading = isSetNewPasswordButtonLoading;
    },
    updateIsConfirmRegistrationButtonLoadingMutation(
      state?: any,
      isConfirmRegistrationButtonLoading?: boolean
    ) {
      state.isConfirmRegistrationButtonLoading = isConfirmRegistrationButtonLoading;
    },
    updateIsAllTransactionsGridLoadingMutation(
      state?: any,
      isAllTransactionsGridLoading?: boolean
    ) {
      state.isAllTransactionsGridLoading = isAllTransactionsGridLoading;
    },
    updateIsDashboardTransactionsGridLoadingMutation(
      state?: any,
      isDashboardTransactionsGridLoading?: boolean
    ) {
      state.isDashboardTransactionsGridLoading = isDashboardTransactionsGridLoading;
    }
  },
  state: {
    isMenuActive: true,
    isMobileMenuActive: true,
    isCardLostActiveModale: false,
    isCardStolenActiveModale: false,
    isGenericErrorModaleActive: false,
    genericErrorModalMessage: null,
    isActiveDisplayChangePINModale: false,
    isActiveFreezeCardModale: false,
    isActiveSetNewPinModale: false,
    isLoginButtonLoading: false,
    isRegistrationProceedButtonLoading: false,
    isSendingInvitationEmailButtonLoading: false,
    isUpdateMyVehicleButtonLoading: false,
    isFreezeCardButtonLoading: false,
    isActivateCardButtonLoading: false,
    isReportCardLostButtonLoading: false,
    isReportCardStolenButtonLoading: false,
    is2FALoginButtonLoading: false,
    isPostCardNumberToSendResetPasswordSmsCodeButtonLoading: false,
    isSetNewPasswordButtonLoading: false,
    isConfirmRegistrationButtonLoading: false,
    isAllTransactionsGridLoading: false,
    isDashboardTransactionsGridLoading: false,
    isDisplayPinModaleActive: false,
    isActiveConfirmSetNewPinModale: false
  }
};
